import { PerspectiveCamera } from '@react-three/drei';
import type { ComponentProps } from 'react';

export interface PlayerDefaultCameraProps
  extends ComponentProps<typeof PerspectiveCamera> {}

export default function PlayerDefaultCamera({
  makeDefault = true,
  ...props
}: PlayerDefaultCameraProps) {
  return <PerspectiveCamera makeDefault={makeDefault} {...props} />;
}
